<template>
	<div id="app">
    <CampaignTopBanner :visible="standaloneCampaignBannerVisible" />
		<transition name="fade-page" mode="out-in">
			<router-view />
		</transition>
    <CampaignPromotions />
	</div>
</template>
<script>
import CampaignPromotions from "@/components/activity11/CampaignPromotions.vue";
import CampaignTopBanner from "@/components/activity11/CampaignTopBanner.vue";
import { getCampaignPhase } from "@/utils/doubleEleven";

const standaloneCampaignPages = [
  "/home",
  "/homeDownload",
  "/materialDown",
  "/privilege",
  "/materialPreview",
  "/materialSearch",
  "/blog",
  "/balance",
  "/members",
  "/accountInfo",
];

export default {
  components: { CampaignPromotions, CampaignTopBanner },
  data() {
    return { campaignNow: Date.now(), campaignTimer: null };
  },
  computed: {
    standaloneCampaignBannerVisible() {
      const path = this.$route.path.replace(/\/+$/, "") || "/";
      return (
        !this.$route.meta.hideHeader &&
        standaloneCampaignPages.includes(path) &&
        ["upcoming", "active"].includes(getCampaignPhase(this.campaignNow))
      );
    },
  },
  mounted() {
    this.campaignTimer = setInterval(() => {
      this.campaignNow = Date.now();
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.campaignTimer);
  },
};
</script>
<style lang="scss">
html,body{
  width: 100%;
  height: 100%;
}
#app {
  width: 100%;
	height: 100%;
}
</style>
